module.exports = __webpack_public_path__ + "img/savillsbyluisa.53ffe8e0.jpg";